import { Link } from "react-router-dom";
import { clinicInfo } from "../data";

export default function VoksenSenior() {
  const heroImg = "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/voksen-senior-kiropraktor-assens_1.jpg";
  const secondaryImg = "https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/conscious-design-o50fbhpigc8-unsplash_2.jpg";

  const behandlerVi = [
    "Nakkesmerter",
    "Rygsmerter",
    "Pakkeforløb ved diskusprolaps",
    "Sportsskader",
    "Hovedpine og svimmelhed",
    "Smerter i lænd, bækken og balder"
  ];

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      {/* Breadcrumb */}
      <nav className="flex mb-8 text-sm text-brand-600 font-medium">
        <Link to="/" className="hover:text-brand-800">Forside</Link>
        <span className="mx-2">/</span>
        <span className="text-brand-900 font-semibold">Voksne & Seniorer</span>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        {/* Main Content (8 cols) */}
        <article className="lg:col-span-8 space-y-12 text-left">
          {/* Hero Image */}
          <div className="overflow-hidden rounded-3xl border border-brand-100 shadow-md">
            <img
              src={heroImg}
              alt="Voksen og senior kiropraktor Assens"
              className="w-full h-[400px] object-cover object-center"
            />
          </div>

          {/* Intro Section */}
          <div className="space-y-6">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-brand-950 leading-tight">
              Kiropraktik for voksne & seniorer
            </h1>
            <h2 className="text-2xl font-bold font-display text-brand-800">
              Hvorfor gå til kiropraktor?
            </h2>
            <p className="text-lg text-brand-800 leading-relaxed">
              Der kan være mange grunde til, at vores patienter opsøger vores klinik. Som kiropraktor behandler vi en lang række symptomer og sygdomme, så din hverdag bliver nemmere.
            </p>
            <p className="text-brand-800 leading-relaxed">
              Om du døjer med rygproblemer, nakkeproblemer, svimmelhed, hovedpine eller udstrålingsproblemer, så lindrer og behandler vi. Er du i tvivl, om vi kan hjælpe dig, så kontakt klinikken og hør mere.
            </p>
            <div className="pt-2">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center rounded-full bg-brand-600 px-8 py-3.5 text-base font-semibold text-white shadow-md hover:bg-brand-700 transition-all duration-200 cursor-pointer"
              >
                Kontakt os
              </Link>
            </div>
          </div>

          {/* Section: Vi tager hånd om din krop */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Vi tager hånd om din krop
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Det er heldigvis de fleste, vi selv kan hjælpe. Din kiropraktor er et godt og sikkert valg, når du behøver hjælp til at udføre ændringer i de nerveceller, der findes omkring kroppens led og i musklerne, så de kan kommunikere bedre med hjernen, og dine gener lindres. Vi behandler bl.a.:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
              {behandlerVi.map((symptom, idx) => (
                <div key={idx} className="flex items-center gap-3 bg-brand-50/50 p-4 rounded-xl border border-brand-100/50">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-100 text-brand-700 text-xs font-bold">
                    <i className="fa-solid fa-check text-[10px]" />
                  </span>
                  <span className="text-sm font-semibold text-brand-900">{symptom}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Section: Hvorfor vælge os? */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Hvorfor vælge os?
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Hvis du har ondt i hovedet, en dårlig skulder eller en begyndende hælspore, kan det være svært at finde ud af, hvem, der kan hjælpe. Der findes nemlig rigtig mange forskellige typer behandling, og det gør det svært at vælge, om du skal opsøge læge, kiropraktor, fysioterapeut, massør eller en helt anden type behandling?
            </p>
            <p className="text-brand-800 leading-relaxed">
              Hos Kiropraktisk Klinik Assens kombinerer vi flere forskellige behandlingsteknikker, og tilpasser dem til lige netop dig og dit problem. Vi stikker ikke i dig, hvis du er bange for nåle, og vi knækker ikke din ryg, hvis du ikke har lyst til det. For som sagt kan problemer løses på mange måder.
            </p>
            <div className="pt-2">
              <Link
                to="/om-os"
                className="inline-flex items-center gap-2 text-brand-600 hover:text-brand-800 font-semibold text-sm transition-colors"
              >
                Læs mere om klinikken
                <i className="fa-solid fa-arrow-right text-xs" />
              </Link>
            </div>
          </div>

          {/* Section: Rygsmerter er den største folkesygdom */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Rygsmerter er den største folkesygdom
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Det er desværre helt normalt at have ondt i ryggen. Hvert år døjer næsten halvdelen af os med rygproblemer. Det betyder heldigvis ikke, at der ikke er noget at gøre ved det.
            </p>
            <div className="pt-2">
              <Link
                to="/behandlinger/ryg"
                className="inline-flex items-center gap-2 text-brand-600 hover:text-brand-800 font-semibold text-sm transition-colors"
              >
                Læs mere om kiropraktor og rygsmerter
                <i className="fa-solid fa-arrow-right text-xs" />
              </Link>
            </div>
          </div>

          {/* Section: Varierende behandlinger & Evidens */}
          <div className="space-y-8 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Varierende og evidensbaserede behandlingsformer
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-7 space-y-6">
                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Varierende behandlinger</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Vi ser tit smerte i ryggen på vores brikse, men vi kan også meget andet på klinikken. Vi er uddannet til at behandle problemer i hele bevægeapparatet. Vi kan hjælpe med alt fra tennisalbue til hovedpine. Vi kan behandle lidelser eller mindske udfordringer i dagligdagen, som ofte overrasker mange. Vi opfordrer derfor til at tage en snak med os, hvis du oplever et gennemgående problem som f.eks. svimmelhed. Kroppen er forbundet på mange måder, og løsningen findes måske hos os.
                  </p>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    På hjemmesiden <a href="http://www.kiropraktorguide.dk/" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline font-medium">www.kiropraktorguide.dk</a> kan du læse meget mere om, hvad smerter forskellige steder i kroppen kan skyldes.
                  </p>
                </div>

                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Evidensbaserede behandlingsformer</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Hos os får du altså både høj faglighed og samtidig mulighed for mange typer behandling. Vi sørger for at sætte tid nok af til både at lytte, diagnosticere, behandle og forebygge. Vi bruger hovedet lige så meget, som vi bruger vores hænder. Selv om konsultationerne hos os er længere end hos de fleste andre kiropraktorer, er prisen stadig den samme.
                  </p>
                </div>
              </div>

              <div className="md:col-span-5 space-y-6">
                <div className="overflow-hidden rounded-2xl border border-brand-100 shadow-sm aspect-4/3">
                  <img
                    src={secondaryImg}
                    alt="Evidensbaseret kiropraktisk behandling"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="bg-brand-50 p-6 rounded-2xl border border-brand-100 text-center">
                  <p className="text-sm text-brand-900 font-semibold mb-3">Vil du vide mere om forskningen?</p>
                  <Link
                    to="/evidens"
                    className="inline-flex w-full items-center justify-center rounded-full bg-brand-600 py-2.5 text-sm font-bold text-white shadow-xs hover:bg-brand-700 transition-colors cursor-pointer"
                  >
                    Evidens og kiropraktik
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* Sidebar (4 cols) */}
        <aside className="lg:col-span-4 space-y-8 text-left sticky top-24">
          {/* Booking Card */}
          <div className="rounded-3xl bg-brand-900 text-white p-8 shadow-lg space-y-6">
            <h3 className="text-xl font-bold font-display text-white">Bestil tid i dag</h3>
            <p className="text-sm text-brand-200 leading-relaxed">
              Døjer du med smerter eller nedsat bevægelighed? Bestil en tid online eller ring til os for en uforpligtende snak.
            </p>
            <div className="space-y-4 pt-2">
              <a
                href={clinicInfo.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center rounded-full bg-white py-3.5 text-sm font-bold text-brand-900 shadow-sm hover:bg-brand-50 transition-all duration-200 hover:scale-102 active:scale-98 cursor-pointer"
              >
                Bestil tid online
              </a>
              <a
                href={`tel:${clinicInfo.phone}`}
                className="flex w-full items-center justify-center rounded-full bg-brand-800 border border-brand-700 py-3.5 text-sm font-bold text-white hover:bg-brand-700 transition-colors cursor-pointer"
              >
                <i className="fa-solid fa-phone mr-2" />
                <span className="whitespace-nowrap">{clinicInfo.phone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4")}</span>
              </a>
            </div>
          </div>

          {/* Opening Hours Card */}
          <div className="rounded-3xl bg-white border border-brand-100 p-8 shadow-xs space-y-6">
            <h3 className="text-lg font-bold font-display text-brand-950 border-b border-brand-100 pb-3">
              Åbningstider
            </h3>
            <div className="space-y-3 text-sm text-brand-800">
              {clinicInfo.openingHours.map((item) => (
                <div key={item.day} className="flex justify-between border-b border-brand-50 pb-1.5">
                  <span>{item.day}</span>
                  <span className="font-semibold text-brand-900">{item.hours}</span>
                </div>
              ))}
              <div className="pt-2 text-xs text-brand-600">
                <p className="font-semibold text-brand-800">Telefontider:</p>
                <p className="mt-1">{clinicInfo.telefontider}</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
